import { render, staticRenderFns } from "./hrmKpiDossier.vue?vue&type=template&id=9b010664&"
import script from "./hrmKpiDossier.vue?vue&type=script&lang=js&"
export * from "./hrmKpiDossier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports